(function () {
  // Helper selectors
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function getDataset() {
    const el = $('#shiftToZeroDataset[data-shift="to-zero"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function getVariantInput() {
    return $('.product-buy-buttons--input[name="id"]');
  }

  function getPlanRadios() {
    const root = $('#taper-plan-radios');
    if (!root) return null;
    return {
      root,
      forty: root.querySelector('input[value="40-Day Plan"]'),
      hundred: root.querySelector('input[value="100-Day Plan"]')
    };
  }

  function makeSelect(options, plan = 1) {
    const wrap = document.createElement('div');
    wrap.className = 'ghost-plan-select-wrap';
    const label = document.createElement('label');
    label.textContent = 'Choose Strength:';
    const select = document.createElement('select');
    (options || []).forEach(o => {
      const opt = document.createElement('option');
      opt.value = String(o.id);
      opt.textContent = o.title.replace(/^(100|40)-Day Plan:\s*/i, '');
      opt.dataset.price = String(o.price);
      select.appendChild(opt);
    });
    wrap.appendChild(label);
    wrap.appendChild(select);
    const mainRoot = document.querySelector('.main-product--root');
    if( plan == 1 ){
      var iconImg = mainRoot?.dataset.iconImg1;
      var iconText = mainRoot?.dataset.iconText1;
    }else{
      var iconImg = mainRoot?.dataset.iconImg2;
      var iconText = mainRoot?.dataset.iconText2;
    }
    wrap.insertAdjacentHTML(
      'beforeend',
      `
      <div class="icon-row-mobile-column" style="display:flex;justify-content:space-around;margin-top:16px;font-size:13px;text-align:center;color:#333;">
        <div style="display:flex;align-items:center;gap:6px;text-align: left;">
          ${iconImg ? `<img src="${iconImg}" alt="Icon" style="width:16px;height:16px;">` : ""}
          ${iconText || ""}
        </div>
      </div>
      `
    );
    return { wrap, select };
  }

  function mountUnder(planValue, node) {
    const radios = getPlanRadios();
    if (!radios) return null;
    const input = radios.root.querySelector(`input[value="${planValue}"]`);
    const card = input.closest('.taper-plan-option');
    const text = card.querySelector('.taper-plan-text') || card;
    if (!text) return null;

    let slot = text.querySelector(`[data-ghost-slot="${planValue}"]`);
    if (!slot) {
      slot = document.createElement('div');
      slot.setAttribute('data-ghost-slot', planValue);
      text.appendChild(slot);
    }
    slot.innerHTML = '';
    slot.appendChild(node);

    // unhide up the tree if parent was hidden
    let el = slot;
    while (el && el !== document.body) {
      const cs = getComputedStyle(el);
      if (cs.display === 'none') el.style.display = 'block';
      if (cs.visibility === 'hidden') el.style.visibility = 'visible';
      el = el.parentElement;
    }
    return slot;
  }

  function setVariantId(id) {
    const input = getVariantInput();
    if (!input) return;
    const v = String(id);
    if (input.value !== v) {
      input.value = v;
      input.setAttribute('value', v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updatePriceForActivePlan();

      // 🔑 Fire variantChanged event so carousel updates
      const ds = getDataset();
      const allVariants = [...(ds.forty || []), ...(ds.hundred || [])];
      const variant = allVariants.find(vr => String(vr.id) === v);
      if (variant) {
        var mediaId = variant.featured_media.id;
        const thumb = document.querySelector(
          `.product-media--thumbs-wrapper [data-id="${mediaId}"]`
        );
        if (thumb) {
          thumb.click();
          console.log("Clicked thumbnail for media", mediaId);
        } else {
          console.warn("No thumbnail found for media", mediaId);
        }
      }
    }
  }

  function hideNativePickers() {
    $$('.product-form--block[data-block-type="options"], .disclosure--root').forEach(el => el.style.display = 'none');
  }

  function updatePriceForActivePlan() {
    // Remove old price spans from all labels
    document.querySelectorAll('.ghost-plan-select-wrap label .cs-price-el').forEach(span => span.remove());

    const activeRadio = document.querySelector(`input[name="properties[Taper Plan]"]:checked`);
    if (!activeRadio) return;

    // Find the select tied to the active plan
    const select = activeRadio
      .closest('.taper-plan-option')
      .querySelector('.ghost-plan-select-wrap select');
    if (!select) return;

    const opt = select.options[select.selectedIndex];
    if (!opt) return;

    // Ensure price is numeric cents
    let rawPrice = opt.dataset.price || '';
    rawPrice = rawPrice.replace(/[^0-9.]/g, ''); // remove symbols
    let priceCents = Math.round(parseFloat(rawPrice) * 100);

    let formattedPrice;
    let formattedPerCan;

    // Format using Shopify's currency helper if available
    if (window.Shopify && Shopify.formatMoney && !isNaN(priceCents)) {
      formattedPrice = Shopify.formatMoney(priceCents);
      formattedPerCan = Shopify.formatMoney(Math.round(7.99 * 100)); // static per-can
    } else {
      // Fallback formatting
      formattedPrice = `$${(priceCents / 100).toFixed(2)}`;
      formattedPerCan = `$${(7.99).toFixed(2)}`;
    }

    // Append span with both formatted prices in separate spans
    const labelEl = select.closest('.ghost-plan-select-wrap').querySelector('label');
    if (labelEl) {
      const priceWrapper = document.createElement('span');
      priceWrapper.className = 'cs-price-el';

      const priceSpan = document.createElement('span');
      priceSpan.className = 'cs-price'; // for formattedPrice
      priceSpan.textContent = ` ${formattedPrice}`;

      const perCanSpan = document.createElement('span');
      perCanSpan.className = 'cs-price-per-can'; // for formattedPerCan
      perCanSpan.textContent = ` (${formattedPerCan}/Can)`;

      priceWrapper.appendChild(priceSpan);
      priceWrapper.appendChild(perCanSpan);

      labelEl.appendChild(priceWrapper);
    }

  }



  function init() {
    const ds = getDataset();
    const radios = getPlanRadios();
    const idInput = getVariantInput();
    if (!ds || !radios || !idInput) {
      // In the theme editor these elements can be late—try again
      requestAnimationFrame(init);
      return;
    }

    const fortyUI = makeSelect(ds.forty || [], 1);
    const hundredUI = makeSelect(ds.hundred || [], 2);

    mountUnder('40-Day Plan', fortyUI.wrap);
    mountUnder('100-Day Plan', hundredUI.wrap);

    function syncVisibility() {
      const show40 = !!radios.forty?.checked;
      const show100 = !!radios.hundred?.checked;
      fortyUI.wrap.style.display = show40 ? 'block' : 'none';
      fortyUI.select.disabled = !show40;
      hundredUI.wrap.style.display = show100 ? 'block' : 'none';
      hundredUI.select.disabled = !show100;
    }

    fortyUI.select.addEventListener('change', () => setVariantId(fortyUI.select.value));
    hundredUI.select.addEventListener('change', () => setVariantId(hundredUI.select.value));

    function onPlanChanged() {
      if (radios.forty?.checked && fortyUI.select.options.length) {
        fortyUI.select.selectedIndex = 0;
        setVariantId(fortyUI.select.value);
      } else if (radios.hundred?.checked && hundredUI.select.options.length) {
        hundredUI.select.selectedIndex = 0;
        setVariantId(hundredUI.select.value);
      }
      syncVisibility();
      hideNativePickers();
    }

    radios.root.addEventListener('change', e => {
      if (e.target?.name === 'properties[Taper Plan]') onPlanChanged();
    });

    // Initial state
    if (radios.hundred?.checked && hundredUI.select.options.length) {
      setVariantId(hundredUI.select.value);
    } else if (fortyUI.select.options.length) {
      setVariantId(fortyUI.select.value);
    }
    syncVisibility();
    hideNativePickers();
    updatePriceForActivePlan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor support: re-init if the product section reloads
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();